import React from 'react';

interface BrandLogoProps {
  inverse?: boolean;
  compact?: boolean;
}

/**
 * Lockup de marca. El nombre es CitasClinicas.AI y el sufijo `.AI` va en el
 * color de acento, el mismo tratamiento que usan el panel y la splash de la app
 * (server/plugins/platform-shell.ts en el repo reserva-ya).
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  inverse = false,
  compact = false,
}) => (
  <span
    className={`brand-lockup${inverse ? ' brand-lockup--inverse' : ''}${
      compact ? ' brand-lockup--compact' : ''
    }`}
    aria-label="CitasClinicas.AI"
  >
    <span className="brand-mark" aria-hidden="true">
      <span />
    </span>
    <span className="brand-word">
      CitasClinicas<em>.AI</em>
    </span>
  </span>
);

export default BrandLogo;
